import { FC, ReactElement, ReactNode } from 'react';
import { styled, Box, Button } from '@mui/material';
import EastIcon from '@mui/icons-material/East'

interface Props {
  title: ReactNode
  description: ReactNode
  buttonTitle: string
  icon?: ReactElement;
  buttonAction?: () => void
  amount?: number
  showButton?: boolean;
}
const StyledContainer = styled(Box)(({ theme  }) => ({

    ".notification-retard-amount": {
      marginBottom: '12px',
      marginLeft: 'auto',
     float: 'right'
    },
    ".notification-retard-amount .notification-retard-button": {
      display: 'flex',
      alignstems: 'center',
    },
    ".notification-retard-payment" : {
      padding: "9px",
      borderRadius: "25px",
    },
    ".notification-retard-title":{
      color:'white',
      fontWeight: 200,
      fontSize: '1.2rem',
     },
    " .notification-retard-details" :{
      display: 'flex',
      justifyContent: 'space-between'
    },
    ".notification-retard-button":{
      padding: '0.8rem 2rem',
      backgroundColor: '#1A1A1A',
      color: 'white',
      border: 'none',
      borderRadius: '9px',
      cursor: 'pointer',
    },
  ".notification-description": {
    fontSize: '2rem',
    color: '#E6492D',
  },
  ".notification-amount": {
    fontWeight: 200,
    color: '#E6492D',
    fontSize: '2rem',
    marginTop: '0.5rem',
  },
  ".mobiletitle": {
    textTransform: 'none'  
  },
  '@media (max-width: 600px)': {
    ".mobiletitle": {
      display: 'none', 
    },
    ".notification-retard-button": {
      padding: theme.spacing(1), 
      minWidth: theme.spacing(5), 
      width: theme.spacing(5), 
      height: theme.spacing(5), 
      borderRadius: '13%', 
      backgroundColor: '#1A1A1A',
      '& svg': { 
        fontSize: '1.2rem', 
      },
      display: 'flex',
      justifyContent: 'center', 
      alignItems: 'center', 
    },
  },
  '@media (min-width: 601px) and (max-width: 1024px)': {
  },
}));

const DelayNotificationContainer: FC<Props> = ({ title, description, buttonTitle, icon, buttonAction, amount,showButton = true  }) => {
  return (
    <StyledContainer>
       <Box className="notification-retard-payment">
            <Box className="notification-retard-title">{title}</Box>
            <Box className="notification-retard-details">
            {amount !== undefined ? <Box className="notification-amount"> {icon} {amount}$</Box>: <Box className="notification-amount"> {description}$</Box>}
              <Box className="notification-retard-amount"> 
              {showButton && ( <Button className="notification-retard-button" onClick={buttonAction}>
               <Box  sx={{ml:2}} className='mobiletitle'>{buttonTitle} </Box> 
                <EastIcon />
                </Button> 
                     )}
                </Box>
            </Box>
          </Box>
    </StyledContainer>
  )
}

export default DelayNotificationContainer
